module.exports = __webpack_public_path__ + "img/contact_main_bg.b6f02139.jpg";